RivalIQ.module('enums', function (enums) {

    'use strict';

    enums.pageType = {
        1: {
            name: 'Home',
            id: 1
        },
        2: {
            name: 'Pricing',
            id: 2
        },
        3: {
            name: 'About',
            id: 3
        },
        4: {
            name: 'Team',
            id: 4
        },
        5: {
            name: 'Product',
            id: 5
        },
        6: {
            name: 'Blog',
            id: 6
        },
        7: {
            name: 'Investors',
            id: 7
        },
        8: {
            name: 'Jobs',
            id: 8
        },
        9: {
            name: 'Customers',
            id: 9
        },
        10: {
            name: 'Partners',
            id: 10
        },
        11: {
            name: 'Portfolio',
            id: 11
        },
        12: {
            name: 'Press',
            id: 12
        },
        13: {
            name: 'Other',
            id: 13
        },
        14: {
            name: 'Contact',
            id: 14
        },
        15: {
            name: 'Practice Area',
            id: 15
        },
        16: {
            name: 'Promotion',
            id: 16
        }
    };
});
